import { useEffect, useState } from "react";
import { cashPolicyDisclaimer } from "@/mocks/store";

interface CashPolicyModalProps {
  open: boolean;
  mode: "enable" | "view";
  onAccept: () => void;
  onClose: () => void;
}

export default function CashPolicyModal({
  open,
  mode,
  onAccept,
  onClose,
}: CashPolicyModalProps) {
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (open) setAgreed(false);
  }, [open]);

  if (!open) return null;

  const canEnable = mode === "view" || agreed;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground-950/50 yc-fade-in"
        onClick={onClose}
        aria-hidden="true"
      ></div>

      <div className="relative z-10 w-full max-w-lg yc-pop bg-white rounded-card border border-background-200 shadow-pop flex flex-col max-h-[90vh]">
        <div className="shrink-0 flex items-start justify-between gap-3 px-6 pt-6 pb-4 border-b border-background-100">
          <div className="flex items-start gap-3">
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 text-xl">
              <i className="ri-money-dollar-box-line"></i>
            </span>
            <div>
              <h3 className="text-lg font-bold text-foreground-950">
                سياسة الدفع النقدي
              </h3>
              <p className="mt-0.5 text-xs text-foreground-500">
                {mode === "enable"
                  ? "اقرأ السياسة وأكّد الموافقة قبل تفعيل الدفع النقدي."
                  : "ملخّص سياسة الدفع النقدي المعتمدة في حسابك."}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full text-foreground-500 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            aria-label="إغلاق"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-3">
          <div className="flex items-start gap-3 rounded-btn border border-accent-300 bg-accent-50 px-4 py-4">
            <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-white text-accent-800">
              <i className="ri-error-warning-line"></i>
            </span>
            <div>
              <h4 className="text-sm font-bold text-accent-900">
                إخلاء مسؤولية الدفع النقدي (الكاش)
              </h4>
              <div className="mt-2 space-y-3">
                {cashPolicyDisclaimer.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="text-sm leading-7 text-foreground-700"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>

          {mode === "enable" && (
            <label className="flex items-start gap-3 rounded-btn border border-background-200 px-4 py-3 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(event) => setAgreed(event.target.checked)}
                className="mt-1 w-4 h-4 accent-primary-500 cursor-pointer"
              />
              <span className="text-sm font-medium text-foreground-800">
                أوافق على سياسة الدفع النقدي
              </span>
            </label>
          )}
        </div>

        <div className="shrink-0 flex flex-col sm:flex-row gap-3 px-6 py-4 border-t border-background-100">
          {mode === "enable" ? (
            <>
              <button
                type="button"
                onClick={onClose}
                className="flex-1 inline-flex items-center justify-center h-11 rounded-btn bg-background-100 px-6 text-sm font-semibold text-foreground-700 hover:bg-background-200 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                إلغاء
              </button>
              <button
                type="button"
                onClick={onAccept}
                disabled={!canEnable}
                className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-btn bg-primary-500 px-6 text-sm font-semibold text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <i className="ri-check-line"></i>
                موافق وتفعيل الدفع النقدي
              </button>
            </>
          ) : (
            <button
              type="button"
              onClick={onClose}
              className="w-full inline-flex items-center justify-center h-11 rounded-btn bg-primary-500 px-6 text-sm font-semibold text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              حسناً، فهمت
            </button>
          )}
        </div>
      </div>
    </div>
  );
}